import React, { useState, useEffect } from "react";
import { Form, Col, Row, Button, Select, Input, Alert } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import { defaultValidateMessages } from "./Helper";

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};

const PosRoutingRuleAddForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [cardBrandSelect, setCardBrandSelect] = useState({
    data: [],
    loading: false,
  });
  const [bankSelect, setBankSelect] = useState({
    data: [],
    loading: false,
  });
  const [form] = Form.useForm();

  useEffect(() => {
    getcardBrands();
    getBanks();
  }, []);

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  const getcardBrands = () => {
    setCardBrandSelect({ data: [], loading: true });

    RequestHandler.get(`/Card/GetCardBrands`).then((res) => {
      setCardBrandSelect({ data: res, loading: false });
    });
  };

  const getBanks = () => {
    setBankSelect({
      ...bankSelect,
      loading: true,
    });
    RequestHandler.get(
      `/PosCollectionBankInfo/AddedBanks?$select=id,name`
    ).then((response) => {
      setBankSelect({
        data: response,
        loading: false,
      });
    });
  };

  const onSuccess = () => {
    form.resetFields();
    if (props.onSuccess) props.onSuccess();
  };

  const onFinish = (values) => {
    RequestHandler.post(`/PosRoutingRule`, values).then((response) => {
      setLoading(false);
      if (response?.success) {
        onSuccess();
      }
    });
  };

  const onFinishFailed = (errorInfo) => {
    setLoading(false);
  };

  return (
    <Form
      {...formItemLayout}
      validateMessages={defaultValidateMessages}
      form={form}
      name="PosRoutingRuleAdd"
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Row>
        <Col span={24}>
          <Form.Item
            label="Kart Markası"
            name="cardBrand"
            rules={[{ required: true }]}
          >
            <Select
              allowClear
              showSearch
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
              loading={cardBrandSelect.loading}
            >
              {cardBrandSelect.data.map((item) => (
                <Select.Option key={item.id} value={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            name="posRoutingBankId"
            label="Banka Tanımı :"
            rules={[{ required: true }]}
          >
            <Select
              allowClear
              showSearch
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
              loading={bankSelect.loading}
            >
              {bankSelect.data.map((item) => (
                <Select.Option key={item.id} value={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label="Önemli Not" name="description">
            {/* Açıklama kutusu */}
            <Alert
              type="info"
              showIcon
              style={{ marginBottom: 8 }}
              message={
                <>
                  Pos Tahsilat'da, Kart markasının tanımlı olduğu Banka'ya ait
                  Pos Komisyon tanımı yok ise, seçilecek Banka Tanımına ait
                  komisyon seçeneklerine yönlendirilir.
                  <br />
                  Seçilen Banka Tanımına ait aktif Pos Komisyon Tanımı'nın
                  olması gerekmektedir.
                </>
              }
            />
          </Form.Item>

          <Row justify="space-between">
            <Col></Col>
            <Col>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                htmlType="submit"
                onClick={() => setLoading(true)}
                loading={loading}
              >
                Ekle
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};
export default PosRoutingRuleAddForm;
